import { render } from "./exclude-from-intros.vue?vue&type=template&id=476189c4&lang=pug"
import script from "./exclude-from-intros.vue?vue&type=script&lang=js"
export * from "./exclude-from-intros.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__